module.exports = __webpack_public_path__ + "static/media/wizualizacja-36.073595ce.png";